import { MAKER_CHECKS_DISABLED_PARTNERS } from '../../../../containers/PolicyApprovalDashboard/stages'

// AccessBank runs maker-checker (one "Agent Approval" stage) but keeps the
// plain Approve/Reject buttons (MAKER_CHECKS_DISABLED_PARTNERS). Policy admin
// refuses a direct status write on an Un_Confirmed policy, so while the policy
// is waiting on a check those buttons must decide the check instead: approving
// the last stage activates the policy, rejecting it rejects the policy.
//
// Returns the maker-check decision body to send, or null when the plain status
// update still applies.
export function singleDecisionMakerCheck(partner, policy, decision, reason) {
  if (MAKER_CHECKS_DISABLED_PARTNERS.indexOf(partner) === -1) {
    return null
  }
  const pending =
    policy &&
    policy.status === 'Un_Confirmed' &&
    Array.isArray(policy.maker_checks) &&
    policy.maker_checks.some(check => check.status === 'Pending')
  if (!pending) {
    return null
  }
  return decision === 'Rejected' ? { decision, reason } : { decision }
}
